import { getAuthenticatedUser, User } from '@libs/focus-frontend-services/src/AuthenticationService';
import { ConsentCategory } from '@libs/focus-frontend-services/src/ConsentService';
import { FeatureFlag, get } from '@libs/focus-frontend-services/src/FeatureFlagService';
import { loadScript } from '@libs/focus-frontend-utils/src/dom';

const planhatTenantUuid = environment.PLANHAT_TENANT_UUID;

const loadPlanhatWidget = () => {
  const initialize = () => {
    const plantrack = window.top!.plantrack || [];
    window.top!.plantrack = plantrack;

    const queueFunctionInitialization = function (t: string) {
      return function () {
        plantrack.push([t].concat(Array.prototype.slice.call(arguments, 0)));
      };
    };

    plantrack['init'] = queueFunctionInitialization('init');
    plantrack['identify'] = queueFunctionInitialization('identify');
    plantrack['track'] = queueFunctionInitialization('track');

    plantrack._endpoint = `https://analytics.planhat.com/analytics/${planhatTenantUuid}`;

    const elementId = 'planhat-js-sdk';

    if (window.document.getElementById(elementId)) {
      return;
    }

    loadScript('https://app.planhat.com/analytics/plantrack.min.js', [
      { qualifiedName: 'id', value: elementId },
      { qualifiedName: 'data-cookieconsent', value: ConsentCategory.Necessary },
      { qualifiedName: 'type', value: 'text/javascript' },
      { qualifiedName: 'defer', value: 'defer' },
      { qualifiedName: 'async', value: 'async' },
    ]).then(() => {
      plantrack.identify(getAuthenticatedUser(User.EmployeeId), {
        externalCompanyId: getAuthenticatedUser(User.AccountId),
      });
    });
  };

  if (document.readyState !== 'complete') {
    window.addEventListener('load', initialize, false);

    return;
  }

  initialize();
};

function initializePlanhatNpsSurvey() {
  const planhatNpsSurveyEnabled = get(FeatureFlag.EnablePlanhatNpsSurvey);

  if (planhatTenantUuid && planhatNpsSurveyEnabled) {
    loadPlanhatWidget();
  }
}

export default initializePlanhatNpsSurvey;
